import React, { useEffect, useState, useRef } from 'react'

interface TabItem {
  label: string
  key?: string
  childs?: TabItem[]
  // component?: React.ReactNode // Eğer component kullanılıyorsa
}

interface TabProps {
  loading: boolean
  tabs: TabItem[]
  selectedTab?: string
  setSelectedTab?: any
}

export default function Tabs({ loading, tabs, selectedTab, setSelectedTab }: TabProps) {
  const [isMobile, setIsMobile] = useState(false)
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const dropdownRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768)
    }
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  useEffect(() => {
    if (!dropdownOpen) return
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setDropdownOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [dropdownOpen])

  const tabChange = (tab: string | undefined) => {
    if (tab && setSelectedTab) {
      setSelectedTab(tab)
      setDropdownOpen(false)
    }
  }

  const findActive = (tab, selectedTab) => {
    if (tab.childs) {
      for (let i = 0; i < tab.childs.length; i++) {
        if (tab.childs[i]?.key === selectedTab) return 'active'
      }
    }

    if (tab.key === selectedTab) return 'active'

    return ''
  }

  if (isMobile) {
    let selectedLabel = ''
    tabs.forEach(tab => {
      if (tab.childs) {
        tab.childs.forEach(child => {
          if (child.key === selectedTab) selectedLabel = child.label
        })
      } else if (tab.key === selectedTab) {
        selectedLabel = tab.label
      }
    })
    if (!selectedLabel && tabs.length > 0) {
      selectedLabel = tabs[0].label
    }
    return (
      <div className='mb-4 position-relative' ref={dropdownRef}>
        <button
          className='btn btn-light d-flex align-items-center justify-content-between w-100'
          style={{ minHeight: 44 }}
          onClick={() => setDropdownOpen(!dropdownOpen)}
          type='button'
        >
          <span>{selectedLabel}</span>
          <span className='ms-2'><i className={'bi ' + (dropdownOpen ? 'bi-chevron-up' : 'bi-chevron-down')}></i></span>
        </button>
        {dropdownOpen && (
          <div
            className='dropdown-menu show w-100 mt-2 shadow-sm p-0 border-0'
            style={{
              display: 'block',
              maxHeight: 320,
              overflowY: 'auto',
              zIndex: 9999,
              position: 'absolute',
              top: '100%',
              left: 0,
              background: '#fff',
              border: '1px solid #eee'
            }}
          >
            {tabs.map((tab, index) =>
              tab.childs ? (
                <React.Fragment key={index}>
                  <div className='dropdown-header fw-bold text-muted px-4 py-2'>{tab.label}</div>
                  {tab.childs.map((child, cidx) => (
                    <button
                      key={cidx}
                      className={'dropdown-item' + (child.key === selectedTab ? ' active' : '')}
                      onClick={() => tabChange(child.key)}
                      type='button'
                    >
                      {child.label}
                    </button>
                  ))}
                  <div className='dropdown-divider my-0'></div>
                </React.Fragment>
              ) : (
                <button
                  key={index}
                  className={'dropdown-item' + (tab.key === selectedTab ? ' active' : '')}
                  onClick={() => tabChange(tab.key)}
                  type='button'
                >
                  {tab.label}
                </button>
              )
            )}
          </div>
        )}
      </div>
    )
  }

  return (
    <>
      <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold'>
        {tabs.map((tab, index) =>
          tab.childs ? (
            <li className={'nav-item dropdown mt-2 me-10 min-w-340px'} key={index}>
              <button
                onClick={() => {
                  if (tab?.key) tabChange(tab?.key)
                }}
                id='tab-elm'
                data-bs-toggle='dropdown'
                data-kt-menu-static="true"
                aria-expanded='false'
                className={'nav-link dropdown-toggle ' + findActive(tab, selectedTab)}
              >
                {tab?.label}
              </button>
              <ul className={`dropdown-menu py-5`}>
                <div className='d-flex flex-column gap-4'>
                  {tab.childs.map((child, index) => (
                    <li key={index}>
                      <button onClick={() => tabChange(child?.key)} className='nav-link nav-item'>
                        {child?.label}
                      </button>
                    </li>
                  ))}
                </div>
              </ul>
            </li>
          ) : (
            <li className='nav-item mt-2' key={index}>
              <button
                onClick={() => tabChange(tab?.key)}
                className={
                  'nav-link text-active-primary ms-0 me-10 py-5 ' + findActive(tab, selectedTab)
                }
              >
                {tab?.label}
              </button>
            </li>
          )
        )}
      </ul>
    </>
  )
}
